import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "../pages/login/login";
import Layout from "../layout/layout";
import ShipmentList from "../pages/shipments/shipmentlist";
import UserList from "../pages/users/userlist";
import CustomerProfile from "../pages/customerprofile/customerprofilelist";
import AddUser from "../pages/users/adduser";
import ProtectedRoutes from "./protectedroutes";
import ViewUser from "../pages/users/viewuser";
import Dashboard from "../pages/dashboard/dashboard";
import AddCustomer from "../pages/customerprofile/addcustomerprofile";
import ViewCustomer from "../pages/customerprofile/viewcustomerprofile";
import ForgotPassword from "../pages/login/forgotpassword";
import ResetPassword from "../pages/login/resetpassword";
import ViewShipment from "../pages/shipments/viewshipment";
import ViewCustomShipToParty from "../pages/customerprofile/shiptoparties/viewcustomshiptoparty";
import EditCustomShipToParty from "../pages/customerprofile/shiptoparties/editcustomshiptoparty";
const RouteConfig = () => {
  return (
    <>
      <Routes>
        <Route index element={<Login />} />
        <Route path="/" element={<Login />} />
        <Route path="login" element={<Login />} />
        <Route path="forgotpassword" element={<ForgotPassword />} />
        <Route path="resetpassword" element={<ResetPassword />} />
        <Route element={<ProtectedRoutes />}>
          <Route path="layout" element={<Layout />}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="shipments" element={<ShipmentList />} />
            <Route path="users" element={<UserList />} />
            <Route path="adduser" element={<AddUser />} />
            <Route path="viewuser/:userid" element={<ViewUser />} />
            <Route path="edituser/:userid" element={<AddUser />} />
            <Route path="customerprofiles" element={<CustomerProfile />} />
            <Route path="addcustomer" element={<AddCustomer />} />
            <Route path="viewcustomer/:custid" element={<ViewCustomer />} />
            <Route path="editcustomer/:custid" element={<AddCustomer />} />
            <Route path="viewshipment/:ShipmentDetailId/:DeliveryDetailId" element={<ViewShipment />} />
            <Route path="viewcustomshiptoparty/:id" element={<ViewCustomShipToParty />} />
            <Route path="editcustomshiptoparty/:id" element={<EditCustomShipToParty />} />
          </Route>
        </Route> 
        <Route path="*" element={<Login />} />
      </Routes>
    </>
  ) ;
};
export default RouteConfig;
